<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="cooperation">
    <div class="w overflow-hidden">
      <Row class="component-title">
        <Col span="24" class="mb-8px">共享合作</Col>
        <Col span="24" class="component-description">
          北大智慧医学中心作为整合大量样本资源的平台，依靠平台能力和开放共享机制，开放样本以及数据资源，共享平台设施，推动生命健康领域科研、产业和民生快速高效发展。
        </Col>
      </Row>
      <Row
        v-for="item in cooperations"
        :key="item.id"
        class="cooperation-content overflow-hidden"
      >
        <Col span="24" class="cooperation-content-title">{{ item.name }}</Col>
        <Col
          v-for="child in item.children"
          :key="child.id"
          span="6"
          class="h-full content"
        >
          <div
            class="cooperation-content-box w-full h-full relative overflow-hidden"
            :style="`background-image: url(${child.image});`"
          >
            <Row
              type="flex"
              justify="center"
              align="middle"
              class="w-full cooperation-detail absolute pin-b pin-l cursor-pointer"
              @click.native="link(child.link)"
            >
              <Col span="20" class="detail-text">
                <div class="title">{{ child.title }}</div>
                <div>
                  {{ child.content }}
                </div>
              </Col>
              <Col span="4" class="text-right">
                <Icon type="ios-arrow-round-forward" class="arrow" />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      <Row class="component-title pb-56px">
        <Col span="24">成果展示</Col>
      </Row>
      <Row class="cooperation-content overflow-hidden">
        <Col
          v-for="item in achievements"
          :key="item.id"
          span="6"
          class="h-full content2"
        >
          <div
            class="cooperation-content-box w-full h-full relative overflow-hidden"
            :style="`background-image: url(${item.image});`"
          >
            <div class="w-full h-full cooperation-detail absolute pin-b pin-l">
              <div class="detail-text h-full relative">
                <div class="title">{{ item.title }}</div>
                <div>
                  {{ item.content }}
                </div>
                <Button
                  ghost
                  class="absolute pin-b"
                  @click.native="link(item.link)"
                  >了解更多</Button
                >
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CooperationComponent',
  props: {},
  mixins: [],
  components: {},
  data() {
    return {
      cooperations: [
        {
          id: '1',
          name: '我要找资源',
          children: [
            {
              id: '1-1',
              title: '样本资源',
              content: '样本资源共享',
              link: 'waiting',
              image: '/static/images/background/cooperation1.png'
            },
            {
              id: '1-2',
              title: '科学专用数据库',
              content: '样本关联干库数据共享',
              link: 'waiting',
              image: '/static/images/background/cooperation2.png'
            },
            {
              id: '1-3',
              title: '数据资源',
              content: '样本关联数据共享',
              link: 'waiting',
              image: '/static/images/background/cooperation3.png'
            },
            {
              id: '1-4',
              title: '高级检索',
              content: '检索您需要的样本库资源',
              link: 'retrieval',
              image: '/static/images/background/cooperation7.png'
            }
          ]
        },
        {
          id: '2',
          name: '我要用平台',
          children: [
            {
              id: '2-1',
              title: '我要存储',
              content: '联系样本库，存储样本',
              link: 'IWant',
              image: '/static/images/background/cooperation4.png'
            },
            {
              id: '2-2',
              title: '我要寻求帮助',
              content: '联系平台获取各种帮助',
              link: 'IWant',
              image: '/static/images/background/cooperation5.png'
            },
            {
              id: '2-3',
              title: '我要建设方案',
              content: '寻求专业意见，建设独立样本库',
              link: 'IWant',
              image: '/static/images/background/cooperation6.png'
            },
            {
              id: '2-4',
              title: '共享合作共识',
              content: '共享、共赢、共创',
              link: 'IWant',
              image: '/static/images/background/cooperation8.png'
            }
          ]
        }
      ],
      achievements: [
        {
          id: 'a-1',
          title: '学术荣誉与获奖',
          content: '北大医学部8人入选2022年度“博新计划”，实现飞跃式提升',
          link: 'waiting',
          image: '/static/images/background/achievement1.png'
        },
        {
          id: 'a-2',
          title: '科研项目',
          content:
            '产前铀暴露与胎儿神经管缺陷风险：中国北方农村妇女的病例对照研究',
          link: 'waiting',
          image: '/static/images/background/achievement2.png'
        },
        {
          id: 'a-3',
          title: '发表论文',
          content:
            'Micronutrient supplementation and pregnancy outcomes: double-blind randomized controlled trial in China',
          link: 'waiting',
          image: '/static/images/background/achievement3.png'
        },
        {
          id: 'a-4',
          title: '技术转化',
          content: '北京大学共有知识产权新冠病毒抗原检测试剂获批',
          link: 'waiting',
          image: '/static/images/background/achievement4.png'
        }
      ]
    }
  },
  computed: {},
  mounted() {},
  methods: {
    link(name) {
      this.$router.push({ name })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.cooperation {
  background-color: #fafafa;
  padding-bottom: 2.6vw; //50px;
  .ivu-btn {
    padding: 0.73vw 1.1vw; //14px 21px;
    font-size: 0.73vw;
    line-height: 1.43;
    color: #3aa69f;
    border-radius: 5px;
    border: 1px solid #3aa69f;
    transition: all 1s;
    -moz-transition: all 1s;
    -webkit-transition: all 1s;
    -o-transition: all 1s;
    &:hover {
      color: $c-white;
      background-color: #3aa69f;
    }
  }
  .component-title {
    padding: 2.97vw 0 0.42vw 0; //57px 0 8px 0;
  }
  .cooperation-content {
    // height: 426px;
    padding-bottom: 3.125vw; //60px;
  }
  .cooperation-content-title {
    padding: 1.83vw 0 1.5625vw 0; //35px 0 30px 0;
    font-size: 1.5625vw;

    color: #111a2e;
  }
  .cooperation-content-box {
    background-image: url('/static/images/background/cooperation1.png');
    background-size: auto 13vw; //250px;
    background-repeat: no-repeat;
    background-position: top center;
    border-radius: 5px;
    transition: all 1s;
    -moz-transition: all 1s;
    -webkit-transition: all 1s;
    -o-transition: all 1s;
    &:hover,
    &.active {
      box-shadow: 0px 0.47vw 1.25vw rgba(168, 168, 168, 0.25); //0px 9px 24px rgba(168, 168, 168, 0.25);
    }
  }

  .cooperation-detail {
    height: 5.73vw; //110px;
    background-color: $c-white;
    padding: 1.3vw 1.93vw 1vw 1.77vw; //25px 37px 20px 34px;
    border: 1px solid #f0f1f2;
    position: absolute;
    border-radius: 0 0 5px 5px;
    .arrow {
      font-size: 3.05vw; //58.5px;
      background-color: $c-white;
      border-radius: 50%;
    }

    transition: all 1s;
    -moz-transition: all 1s;
    -webkit-transition: all 1s;
    -o-transition: all 1s;
  }
  .detail-text {
    color: #646a77;
    font-size: 0.99vw; //19px//1.04vw; //20px;
    z-index: 1;

    .title {
      color: #111a2e;
      font-size: 1.17vw; //22.5px;
      line-height: 1.3;
    }
  }
  .content {
    padding-right: 1.77vw;
    height: 18.33vw; //352px;
    .detail-text {
      white-space: nowrap;
    }
    .cooperation-detail {
      transition: all 1s;
      -moz-transition: all 1s;
      -webkit-transition: all 1s;
      -o-transition: all 1s;
      &:hover,
      &.active {
        height: 7.8125vw; //150px;
        background: linear-gradient(271.59deg, #3fb7b0 7.71%, #239c95 87.9%);
        border: 0 none;
        .detail-text {
          color: $c-white;
          .title {
            color: $c-white;
          }
        }
        .arrow {
          color: #2ea69f;
        }
      }
    }
  }
  .content2 {
    padding-right: 1.77vw;
    height: 23.8vw; //457px;
    .cooperation-content-box {
      background-size: auto 11.2vw; //215px;
    }
    .cooperation-detail {
      height: 12.66vw; //243px;
      border: 0 none;
      padding: 2.08vw 1.77vw 1.51vw 1.77vw;
    }
    .detail-text {
      font-size: 0.83vw; //16px;
    }
  }

  .pb-56px {
    padding-bottom: 2.92vw; //56px;
  }
  .mb-8px {
    margin-bottom: 8px;
  }
}
</style>
